// extracted by mini-css-extract-plugin
export var cardIcon = "_14-5";
export var cardIconUnframed = "_14-9";
export var checkboxCard = "_14-0";
export var checkboxCardSelected = "_14-4";
export var disabled = "_14-2";
export var interactive = "_14-1";
export var outerBorder = "_14-3";
export var spacerMedium = "_14-8";
export var spacerSmall = "_14-7";
export var spacerXsmall = "_14-6";